// extracted by mini-css-extract-plugin
export var body = "_c0-0";
export var sectionHeader = "_c0-4";
export var shortcutColumns = "_c0-2";
export var shortcutList = "_c0-1";
export var shortcutSection = "_c0-3";